import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FlightsState } from './flights.reducers';

export const flightsState = createFeatureSelector<FlightsState>('flights');

// Docking Context
export const flightsSelector = createSelector(flightsState, flights => flights.flights);

// Selects subset of flights
// The subset count is passed in the selector props
export const flightsLimitedSelector = createSelector(flightsState, (flights, props) =>
    flights.flights.slice(0, props.count)
);
